import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { bl_fi_jrnl_line_RowClass, EntityService, GlcodeService, JournalService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { forkJoin, iif, Observable, of, zip } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { SharedUtilitiesHelperFunctions } from '../../helper-functions';

@Component({
  selector: 'app-cash-document-posting-journal-txn',
  templateUrl: './journal-txn.component.html',
  styleUrls: ['./journal-txn.component.css']
})

export class CashDocumentPostingJournalTxnComponent implements OnInit, OnDestroy {
  @Input() cashDoc;
  protected subs = new SubSink();

  gridApi;
  gridColumnApi;
  rowData: [];
  gridOptions = {
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', key: 'totalAndFilter', align: 'left' },
      ]
    },
    defaultColDef: {
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 100,
      flex: 1,
      sortable: true,
      resizable: true,
      suppressCsvExport: true,
      floatingFilter: true
    },
    pagination: true
  }

  columnsDefs = [
    { headerName: 'GL Code', field: 'glcodeName', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Entity', field: 'entityName', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Description', field: 'descr', cellStyle: () => ({ 'text-align': 'left' }) },
    {
      headerName: 'Debit', field: 'amt_debit', type: 'numericColumn',
      valueFormatter: params => params.value? SharedUtilitiesHelperFunctions.currencyFormatter(params.value):'',
    },
    {
      headerName: 'Credit', field: 'amt_credit', type: 'numericColumn',
      valueFormatter: params => params.value? SharedUtilitiesHelperFunctions.currencyFormatter(params.value):'',
    },
  ];

  ccyCode;
  totalDebit: number = 0;
  totalCredit: number = 0;

  constructor(
    protected journalService: JournalService,
    protected glcodeService: GlcodeService,
    protected entityService: EntityService,
  ) {}

  ngOnInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
    this.createData(this.cashDoc);
  }

  createData(cashDoc) {
    console.log('createData', cashDoc)
    const pagination = new Pagination();
    pagination.conditionalCriteria.push({
      columnName: 'cash_document_hdr_guid',
      operator: '=',
      value: cashDoc.bl_fi_cash_document_hdr.guid.toString()
    });

    pagination.conditionalCriteria.push({
      columnName: 'calcTotalRecords',
      operator: '=',
      value: 'false'
    });

    this.subs.sink = this.journalService.getByCriteria(pagination, AppConfig.apiVisa)
      .pipe(
        mergeMap(b => {
          const source: Observable<bl_fi_jrnl_line_RowClass>[] = [];
          console.log('journal', b);
          if (b.data.length > 0) {
            b.data[0].bl_fi_jrnl_lines.forEach(doc => {
              const entity$ = doc.guid_entity_hdr ? this.entityService.getByGuid(doc.guid_entity_hdr.toString(), AppConfig.apiVisa).pipe(
                catchError((err) => of(err))) : of(null);
              const glcode$ = this.glcodeService.getByGuid(doc.glcode_guid.toString(), AppConfig.apiVisa).pipe(
                catchError((err) => of(err)));
              const result$ = zip(entity$, glcode$)
                .pipe(
                  map(([entity, glcode]) => {
                    doc = Object.assign(doc,
                      { entityName: entity ? entity.error ? entity.error.code : entity?.data.bl_fi_mst_entity_hdr.name : "" },
                      { glcodeName: glcode.data.bl_fi_mst_glcode.name }
                    );
                    return doc;
                  })
                )
              source.push(result$);
            })
            return iif(() => b.data[0].bl_fi_jrnl_lines.length > 0,
              forkJoin(source).pipe(map(() => b.data[0])),
              of(b.data[0])
            );
          }
          return of(null);
        })
      ).subscribe(resp => {
        console.log('resp', resp);
        if (resp) {
          this.gridApi.setRowData(resp.bl_fi_jrnl_lines);

          this.ccyCode = resp.bl_fi_jrnl_hdr.ccy_code;
          this.totalCredit = 0;
          this.totalDebit = 0;
          resp.bl_fi_jrnl_lines.forEach(item => {
              this.totalDebit = this.totalDebit + <number>item.amt_debit;
              this.totalCredit = this.totalCredit + <number>item.amt_credit;
          })
        }
      // }, err => {
      //   this.gridApi.setRowData(of(null));
      //   console.error(err);
      })
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
